import * as Yup from 'yup';

const templateValidationSchema = Yup.object().shape({
  Name: Yup.string().required('Name is required'),
  Text: Yup.string().required('Text is required'),
});

export default templateValidationSchema;